import { render, staticRenderFns } from "./RuleActionIncreasePrice.vue?vue&type=template&id=0d0bb99e"
import script from "./RuleActionIncreasePrice.vue?vue&type=script&lang=js"
export * from "./RuleActionIncreasePrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports